import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {combineLatest, Observable} from 'rxjs';
import {AuthSelectors} from '../store/selectors';
import {map, take, tap} from 'rxjs/operators';
import {AuthActions} from '../store/actions';
import {AUTH_CODE} from '../consts';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  constructor(private store: Store,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    //console.log('Can Activate');
    return combineLatest([this.store.select(AuthSelectors.user), this.store.select(AuthSelectors.token)])
      .pipe(
        tap(([user, token]) => {


          if (localStorage.getItem(AUTH_CODE) && !user) {
            this.store.dispatch(AuthActions.loginByAuthCode({auth_code: localStorage.getItem(AUTH_CODE) as string, url: ''}));
            return;
          }

          if (!user && token) {
            this.store.dispatch(AuthActions.loginByToken({url: state.url, queryParams: route.queryParams}));
          }
          if (!user && !token && state.url.indexOf('login') === -1 && state.url.indexOf('change-password') === -1 && state.url.indexOf('register') === -1) {
            this.router.navigate(['/auth/login']);
          }
        }),
        map(([user, token]) => {
          //console.log(state.url.indexOf('login'))
          if (!user && (state.url.indexOf('login') > 0 || state.url.indexOf('change-password') > 0 || state.url.indexOf('register') > 0)) {
            // console.log(state.url.indexOf('login'))
            return true;
          } else {
            return !!user && (user?.routes?.join('|').indexOf(state.url.split('/')[0]+state.url.split('/')[1]) || 0) >= 0;
          }
        }),
        take(1),
      );
  }
}
